
import { Options, Vue } from 'vue-class-component';

@Options({
	name: 'PageNotFoundView',
	components: {},
})
export default class PageNotFoundView extends Vue {}
